import { NgModule } from '@angular/core';

import { FnsFormatPipe } from './fns-format.pipe';

@NgModule({
    declarations: [
        FnsFormatPipe
    ],
    exports: [
        FnsFormatPipe
    ]
})

export class FnsFormatPipeModule {}
